import Chart from 'react-apexcharts'

const BudgetChart = ({
    width = '100%',
    height,
    series,
    categories,
    title
}) => {
    // Fixed color array - ensure you have 4 colors for 4 series
    const customColors = ['#008FFB', '#000302', '#00E396', '#FF4560'];

    return (
        <Chart
            options={{
                chart: {
                    id: 'budget-comparison-chart',
                    type: 'bar',
                    stacked: false,
                    toolbar: {
                        show: true
                    }
                },
                yaxis: {
                    title: {
                        text: title,
                        style: {
                            fontSize: '13px',
                            fontWeight: 'normal'
                        },
                    }
                },
                legend: { 
                    position: 'bottom',
                    show: true,
                    onItemClick: {
                        toggleDataSeries: true
                    },
                    onItemHover: {
                        highlightDataSeries: true
                    }
                },
                xaxis: {
                    categories: categories,
                    labels: {
                        rotate: -45,
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: customColors,
            }}
            series={series} // Use original series (colors are in options)
            type="bar"
            width={width}
            height={height}
        />
    )
}

export default BudgetChart;